import React, { useRef, useEffect, useState } from "react";
import DataGrid, {
	Column,
	Paging,
	FilterRow,
	HeaderFilter,
	SearchPanel,
} from "devextreme-react/data-grid";
import { Popup } from "devextreme-react/popup";
import { Button } from "devextreme-react/button";
import { getUserFirstUseAll, deleteFirstUse } from "../api/apiServiceFetch";

const UserFirstUsePopup = ({ userId, visible, onClose }) => {
	const [orders, setOrders] = useState([]);

	const fetchOrders = async () => {
		if (userId && visible) {
			try {
				const data = await getUserFirstUseAll(userId);
				setOrders(data);
				console.log(userId, data)
			} catch (err) {
				console.error("Ошибка загрузки заказов пользователя:", err);
			}
		}
	};
	useEffect(() => {
		fetchOrders();
	}, [userId, visible]);

	const handleDelete = async (orderId) => {
		try {
			await deleteFirstUse(orderId);
			await fetchOrders(); // Refresh data after deletion
		} catch (err) {
			console.error("Ошибка удаления записи:", err);
		}
	};

	if (!visible) return null;

	return (
		<Popup
			visible={true}
			onHiding={onClose}
			dragEnabled={true}
			showTitle={true}
			title="Одноразки"
			width={800}
			height={500}
		>
			<DataGrid dataSource={orders} keyExpr="id" showBorders={true}>
				<Paging defaultPageSize={10} />
				<FilterRow visible={true} />
				<HeaderFilter visible={true} />
				<Column dataField="id" caption="ID" width={70} />
				<Column
					dataField="type"
					caption="Тип"
					calculateCellValue={(data) => {
						switch (data.type) {
							case 100:
								return "Premium на 3 дня";
							case 3:
								return "Чистый лист 🆕";
							case 5:
								return "Повторная регистрация 🔄";							
							default:
								return data.type;
						}
					}}
				/>

				<Column
					dataField="createDate"
					caption="Создан"
					dataType="date"
					format="dd.MM.yyyy"
				/>
				<Column
					caption="Действия"
					width={100}
					cellRender={(data) => (
						<Button
							text="Удалить"
							type="danger"
							onClick={() => handleDelete(data.data.id)}
						/>
					)}
				/>
			</DataGrid>

			<div style={{ textAlign: "right", marginTop: 10 }}>
				<Button text="Закрыть" onClick={onClose} />
			</div>
		</Popup>
	);
};

export default UserFirstUsePopup;
